import { ApiRequest } from "src/models/api.request";
import VwHbsYatisDTO from "src/models/HastaKayit/VwHbsYatisDTO";
import VwHastaservisListeDTO from "src/models/HastaServis/VwHastaservisListeDTO";
import VwHbsHastaservisDTO from "src/models/HastaServis/VwHbsHastaservisDTO";
import VwHbsServispersonelDTO from "src/models/Settings/Generals/VwHbsServispersonelDTO";
import VwRoldbServistanimDTO from "src/models/Settings/Generals/VwRoldbServistanimDTO";
import api from "src/services/core/api";
import { HastaServisSearch } from "src/store/Slices/HastaServis/HastaServisSlice";
import { YatisKabulModel, YatisKabulSearch } from "src/store/Slices/YatisKabul/YatisKabulSlice";

const controllerName = "hastaservis";

export const HastaServisApi = api.injectEndpoints({
    endpoints: builder => ({
        hastaServisListeGetirBySearchText: builder.query<Array<VwHastaservisListeDTO>, { searchText: string }>({
            query: (request) => ({
                url: controllerName + "/HastaServisListeGetirBySearchText",
                method: "GET",
                params: request
            }),
        }),
        getHastaServisListeById: builder.query<VwHastaservisListeDTO, { id: number }>({
            query: (request) => ({
                url: controllerName + "/GetHastaServisListeById",
                method: "GET",
                params: request
            }),
        }),
        findVwRoldbServistanim: builder.query<Array<VwRoldbServistanimDTO>, {
            kullaniciId: number,
            organizasyonId: number,
            tipId: number,
            servisTip: string
        }>({
            query: (request) => {
                var apiRequest: ApiRequest<VwRoldbServistanimDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            { fieldName: 'kullaniciId', operator: '=', value1: request.kullaniciId },
                            { fieldName: 'organizasyonId', operator: '=', value1: request.organizasyonId },
                            { fieldName: 'tipId', operator: '=', value1: request.tipId },
                            { fieldName: 'fkServistip', operator: 'in', value1: request.servisTip.split(",") },
                        ]
                    },
                    sorts: [{ fieldName: 'adi' }]
                }
                return {
                    url: "VwRoldbServistanimDTO/find",
                    method: "POST",
                    body: apiRequest
                }
            },
            providesTags: ["RoldbServistanim"]
        }),
        findVwHbsServispersonel: builder.query<Array<VwHbsServispersonelDTO>, {
            servisId: Array<number>,
            grupId: Array<number>,
        }>({
            query: (request) => {
                var apiRequest: ApiRequest<VwHbsServispersonelDTO> = {
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            { fieldName: 'fkHbsServistanimId', operator: 'in', value1: request.servisId },
                            { fieldName: 'grupId', operator: 'in', value1: request.grupId }
                        ]
                    },
                    sorts: [{ fieldName: 'adi' }]
                }
                return {
                    url: "VwHbsServispersonelDTO/find",
                    method: "POST",
                    body: apiRequest
                }
            },
            providesTags: ["RoldbServistanim"]
        }),
        getHastaservisListe: builder.query<Array<VwHastaservisListeDTO>, HastaServisSearch>({
            query: (request) => ({
                url: controllerName + "/GetHastaservisListe",
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
        updateVwHastaservisListe: builder.mutation<boolean, VwHbsHastaservisDTO>({
            query: (request) => ({
                url: controllerName + "/UpdateVwHastaservisListe",
                method: "PUT",
                body: JSON.stringify(request)
            })
        }),
        getVwHbsHastaservis: builder.mutation<VwHbsHastaservisDTO, number>({
            query: (id) => ({
                url: "VwHbsHastaservisDTO/" + id,
                method: "GET"
            })
        }),
        addVwHbsYatis: builder.mutation<boolean, VwHbsHastaservisDTO>({
            query: (request) => ({
                url: controllerName + "/HastaYatisTalepEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["YatisTalep"]
        }),
        updateVwHbsYatis: builder.mutation<boolean, VwHbsHastaservisDTO>({
            query: (request) => ({
                url: controllerName + "/HastaYatisTalepGuncelle",
                method: "PUT",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["YatisTalep"]
        }),
        deleteVwHbsYatis: builder.mutation<boolean,
            {
                id: number
            }>({
                query: (request) => ({
                    url: controllerName + "/HastaYatisTalepSil",
                    method: "DELETE",
                    params: {
                        id: request.id
                    }
                }),
                invalidatesTags: ["YatisTalep"]
            }),
        getVwHbsYatisTalepByMuracaatId: builder.query<VwHbsYatisDTO,
            {
                muracaatId: number
            }>({
                query: (request) => ({
                    url: controllerName + "/HastaYatisTalepByMuracaatId",
                    method: "GET",
                    params: {
                        muracaatId: request.muracaatId
                    }
                }),
                keepUnusedDataFor: 0,
                providesTags: ["YatisTalep"]
            }),
        getYatanHastaSorgu: builder.query<VwHbsHastaservisDTO, {
            kimlikId: number
        }>({
            query: (request) => ({
                url: controllerName + "/YatanHastaSorgu",
                method: "GET",
                params: {
                    kimlikId: request.kimlikId
                }
            })
        }),
        getHastaYatisGetir: builder.query<VwHbsYatisDTO[], YatisKabulSearch>({
            query: (request) => ({
                url: controllerName + "/HastaYatisGetir",
                method: "POST",
                body: JSON.stringify(request)
            }),
            providesTags: ["YatisTalep"]
        }),
        addHastaYatisKabul: builder.mutation<boolean, YatisKabulModel>({
            query: (request) => ({
                url: controllerName + "/HastaYatisKabul",
                method: "POST",
                body: JSON.stringify(request)
            }),
            invalidatesTags: ["YatisTalep"]
        }),
        updateHastaYatisRed: builder.mutation<boolean, VwHbsYatisDTO>({
            query: (request) => ({
                url: controllerName + "/HastaYatisRed",
                method: "PUT",
                body: JSON.stringify(request)
            }),
        }),
        hastaServisYatisEkle: builder.mutation<VwHbsHastaservisDTO, VwHbsHastaservisDTO>({
            query: (request) => ({
                url: controllerName + "/HastaServisYatisEkle",
                method: "POST",
                body: JSON.stringify(request)
            }),
        }),
    }),
})

export const {
    useFindVwRoldbServistanimQuery,
    useFindVwHbsServispersonelQuery,
    useLazyGetHastaservisListeQuery,
    useLazyGetHastaServisListeByIdQuery,
    useUpdateVwHastaservisListeMutation,
    useGetVwHbsHastaservisMutation,
    useAddVwHbsYatisMutation,
    useGetYatanHastaSorguQuery,
    useGetVwHbsYatisTalepByMuracaatIdQuery,
    useUpdateVwHbsYatisMutation,
    useDeleteVwHbsYatisMutation,

    useGetHastaYatisGetirQuery,
    useAddHastaYatisKabulMutation,
    useUpdateHastaYatisRedMutation,

    useHastaServisYatisEkleMutation
} = HastaServisApi;